/* @flow */

import * as React from 'react';
import { identity } from 'lodash/fp';

type Props = {};

type State = {
  data: Object,
  errors: Array<*>,
  initialised: boolean,
  loading: boolean
};

function withAPIData({ fetcher, normalizeData = identity, normalizeMeta = identity }) {
  return WrappedComponent =>
    class extends React.Component<Props, State> {
      props: Props;

      state: State = {
        data: {},
        errors: [],
        initialised: false,
        loading: false
      };

      handleFetch = (...args) => {
        this.setState({
          errors: [],
          loading: true
        });

        fetcher(...args).then(this.handleSuccess, this.handleFailure);
      };

      handleSilentFetch = (...args) => {
        this.setState({
          errors: []
        });

        fetcher(...args).then(this.handleSuccess, this.handleFailure);
      };

      handleSuccess = res => {
        this.setState({
          data: normalizeData(res.data),
          meta: normalizeMeta(res.meta),
          initialised: true,
          loading: false
        });
      };

      handleFailure = res => {
        this.setState({
          errors: res.errors,
          initialised: true,
          loading: false
        });
      };

      render() {
        return (
          <WrappedComponent
            data={this.state.data}
            meta={this.state.meta}
            errors={this.state.errors}
            initialised={this.state.initialised}
            loading={this.state.loading}
            onFetch={this.handleFetch}
            onSilentFetch={this.handleSilentFetch}
            {...this.props}
          />
        );
      }
    };
}

export default withAPIData;
